import { TranslocoService } from '@jsverse/transloco';
import { inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { firstValueFrom } from 'rxjs';

// TODO: move it out of here!!
export function translocoInitializer(transloco: TranslocoService) {
    return () => {
        const document = inject(DOCUMENT);
        const path = document.location.pathname;

        const langFromUrl = path.split('/')[1];
        const lang = ['en', 'fr'].includes(langFromUrl) ? langFromUrl : 'en';

        transloco.setActiveLang(lang);

        return firstValueFrom(transloco.load(lang));
    };
}
